import React from "react";
import { MainContainer, CarouselImage } from "../components";
import { PAGES } from "../constants";
import { useNavigate } from "react-router-dom";
import { HiOutlineArrowRight, HiCheckCircle } from "react-icons/hi";
import Carousel from "react-bootstrap/Carousel";
import { motion } from "framer-motion";

import Img1 from "../assets/carousel/car-1.jpg";
import Img2 from "../assets/carousel/car-2.jpg";
import Img3 from "../assets/carousel/car-3.jpg";
import Bg2 from "../assets/bg/bg2.png";
import Sun from "../assets/images/sun.png";

const benefit = [
  {
    id: 1,
    serialNo: "01",
    title: "Tailored Solar Solutions",
    content:
      "At Particle Solar Power, we understand the uniqueness of every solar project. We offer personalized solar module mounting solutions that align with your specific requirements. Whether you need custom mounting structures, design, or consulting services, we work closely with you to create solutions that address your solar challenges and drive success.",
  },
  {
    id: 2,
    serialNo: "02",
    title: "Smart Solar Investments",
    content:
      "Particle Solar Power comprehends the importance of smart investments in the solar industry. Our pricing models are transparent and competitive, ensuring that you access top-quality mounting solutions at a reasonable cost. We focus on optimizing resource utilization to deliver cost-efficient solar mounting solutions without compromising quality.",
  },
  {
    id: 3,
    serialNo: "03",
    title: "Adaptability and Flexibility in Solar",
    content:
      "Our solar offerings are designed to adapt to evolving solar project requirements. Particle Solar Power offers flexible and customizable options to accommodate diverse solar demands. As a leading solar solutions provider, we have a proven track record of effectively implementing solutions for projects of all sizes, from small installations to large solar enterprises.",
  },
  {
    id: 4,
    serialNo: "04",
    title: "Solar Domain Proficiency",
    content:
      "With extensive experience in the solar industry, we have cultivated robust expertise in solar module mounting solutions. Our team of professionals is well-versed in the latest solar technologies and trends, ensuring the delivery of excellent solutions tailored to fulfill your precise solar project requirements.",
  },
  {
    id: 5,
    serialNo: "05",
    title: "Excellence and Dependability in Solar",
    content:
      "Excellence remains at the core of Particle Solar Power's operations. We adhere rigorously to industry best practices and stringent quality assurance protocols to supply resilient, dependable, and scalable solar module mounting solutions. Our unwavering commitment to excellence ensures that you receive products and services that meet the highest benchmarks, empowering your solar projects to outshine the competition.",
  },
  {
    id: 6,
    serialNo: "06",
    title: "Strong Client Partnerships in Solar",
    content:
      "Nurturing customer satisfaction is our paramount objective at Particle Solar Power. We prioritize fostering enduring relationships with our solar clients through exceptional experiences and support. Our dedicated team is perpetually accessible to address your solar inquiries, attend to your concerns, and offer timely aid, ensuring a seamless and trouble-free experience for your solar projects.",
  },
];

const SOLUTIONS = [
  "RCC TYPE PRE & POST GALVANISED",
  "RCC BALLAST GI STRUCTURE",
  "LONG RAIL ALUMINIUM",
  "SOLAR HUT SHAPE STRUCTURE",
  "SOLAR GROUND MOUNTED STRUCTURE",
  "MONO RAIL ALUMINIUM",
];

const WHY_PARTICLE = [
  "One Stop Solar Module Mounting Solutions",
  "Energetic & Dynamic approach for Providing extraordinary benefits to our Clients",
  "Timely Delivery",
  "Competitive Price",
  "Provides excellent on-site support",
  "Superior Quality",
  "Team of Dedicated & Experienced Professionals",
  "Customized/Tailored Solar Mounting Solutions",
];

const PRODUCTS = [
  "GI STRUT SECTION",
  "C-LIP SECTION",
  "C SECTION",
  "PERFORATED GI STRUT SECTION",
  "HAT PURLIN",
  "GI STRIP",
  "CABLE TRAY",
  "FRP WALKWAY",
];

export default function Home() {
  const navigate = useNavigate();

  return (
    <MainContainer>
      <>
        {/* Landing Page */}
        <Carousel>
          {[Img1, Img2, Img3].map((img, idx) => (
            <Carousel.Item key={idx}>
              <CarouselImage img={img} />
              <Carousel.Caption className="h-full w-full">
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                  className="flex flex-col w-full h-full justify-start items-start pt-40 gap-3"
                >
                  <h3 className="text-xl lg:text-5xl text-gray-200 font-bold">
                    {idx === 0 && "Innovative Solar Mounting Solutions"}
                    {idx === 1 && "30+ MW Project Expertise"}
                    {idx === 2 && "Quality and On-time Delivery"}
                  </h3>
                  <p className="text-gray-300 w-[75%] text-lg lg:text-2xl font-normal text-left">
                    {idx === 0 &&
                      "Explore our cutting-edge solar module mounting structures designed for efficiency and durability."}
                    {idx === 1 &&
                      "Benefit from our experience in supplying over 30 megawatts of solar module mounting solutions across India."}
                    {idx === 2 &&
                      "Count on us for the highest quality materials and punctual delivery to meet your solar mounting challenges."}
                  </p>
                  <div className="flex flex-col lg:flex-row gap-4">
                    <a href={PAGES.SERVICES}>
                      <div className="border-2 border-transparent rounded-full px-5 py-3 bg-primary-color hover:border-2  hover:bg-opacity-80 cursor-pointer transition-all duration-200 ease-in">
                        <p>Discover services</p>
                      </div>
                    </a>
                    <a href={PAGES.CONTACT}>
                      <div className="border-1 rounded-full px-5 py-3 hover:bg-primary-color hover:border-transparent transition-all duration-200 ease-in-out cursor-pointer">
                        <p>Request a Quote</p>
                      </div>
                    </a>
                  </div>
                </motion.div>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Company Overview */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="px-8 lg:px-28 text-gray-200"
        >
          <div className="w-full flex flexl items-center bg-overview bg-cover bg-opacity-30 bg-no-repeat mt-20 rounded-3xl ">
            <div className="w-full flex flex-col md:flex-row lg:flex-row  rounded-3xl bg-secondary-color bg-opacity-50  px-8 py-20">
              <div className="w-full flex flex-col gap-4 mb-10 ">
                <div>
                  <p className="text-white text-4xl font-semibold">
                    Particle Solar Power (OPC) Pvt Ltd
                  </p>
                </div>
                <div>
                  <p className="text-white text-lg font-normal">
                    Particle Solar Power (OPC) Pvt Ltd is a trusted and principled leader in the solar industry, dedicated to ensuring the success of our clients through top-quality mounting solutions.
                  </p>
                </div>
              </div>
              <div className="w-full flex flex-col gap-4 ">
                <div>
                  <p className="text-white text-4xl font-semibold">
                    Your Premier Solar Mounting Solutions Provider.
                  </p>
                </div>
                <div>
                  <p className="text-white text-lg font-normal">
                    Particle Solar Power (OPC) Pvt Ltd is a premier player in the solar industry, offering comprehensive consultation and expert execution of your projects as an innovative and forward-thinking tech company.
                  </p>
                </div>
                <div onClick={() => navigate(PAGES.ABOUT)}>
                  <button className="px-3 py-2 border-2 border-white text-white rounded-lg ">
                    More About Particle Solar{" "}
                    <HiOutlineArrowRight className="inline-block ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* what we do */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex flex-col bg-gray-200 mt-10"
        >
          <div className="w-full flex flex-col justify-center items-center  px-8 lg:px-28 py-16 gap-2">
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center text-2xl md:text-4xl lg:text-5xl font-semibold text-primary-color"
            >
              Particle Solar Power Envisions a Unique Path to Solar Excellence.
            </motion.p>
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img src={Sun} alt="SUN" className="w-20  bg-cover" />
            </motion.div>
            <p className="text-center text-lg">
              We excel in the design, installation, and maintenance of solar module mounting structures, serving industrial, residential, and commercial projects. Our customized solutions address each client's energy requirements, reducing their reliance on conventional power sources. Our seasoned team employs high-quality materials to ensure the efficiency and durability of our solar mounting solutions.
            </p>
          </div>

          {/* WHY PARTICLE */}
          <div className="flex flex-col  lg:flex-row w-full">
            <div className="w-full lg:w-[50%] bg-CAR1 bg-cover"></div>
            <div className="w-full lg:w-[50%] bg-gray-600 flex-grow px-10 py-5 text-white">
              <p className="text-2xl mb-2 font-bold">
                WHY <span className="text-primary-color">PARTICLE</span> ?
              </p>
              <ul>
                {WHY_PARTICLE.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="flex flex-row items-center"
                  >
                    <HiCheckCircle className="inline-block mr-2 text-xl text-white" />
                    <li className="text-md lg:text-xl">{item}</li>
                  </motion.div>
                ))}
              </ul>
            </div>
          </div>

          {/* PRODUCTS */}
          <div className="flex flex-col lg:flex-row w-full">
            <div className="w-full lg:w-[50%] bg-gray-600 px-10 py-5 text-white">
              <p className="text-2xl mb-2 font-bold">OUR PRODUCTS</p>
              <ul>
                {PRODUCTS.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="flex flex-row items-center"
                  >
                    <HiCheckCircle className="inline-block mr-2 text-xl text-white" />
                    <li className="text-md lg:text-xl">{item}</li>
                  </motion.div>
                ))}
              </ul>
            </div>
            <div className="w-full lg:w-[50%] bg-CAR2 bg-cover"></div>
          </div>
        </motion.div>

        {/* Company Info */}
        <div className="negative flex flex-col gap-10 items-center   bg-secondary-color bg-opacity-10  px-8 lg:px-28 py-16 ">
          <div className="w-full flex items-center justify-center">
            <p className=" text-center  text-2xl md:text-4xl lg:text-5xl font-semibold text-primary-color">
              Discover Solar Solutions with Particle Solar Power.
            </p>
          </div>

          <div className="w-full flex flex-col md:flex-row lg:flex-row flex-wrap gap-10  justify-center">
            {benefit &&
              benefit.map((item) => (
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: item.id * 0.1 }}
                  key={item.id}
                  className="w-[100%] md:w-[27%] bg-white px-4 py-4 rounded-lg flex flex-col gap-2 shadow-lg relative"
                >
                  <div className="w-full flex flex-col items-center justify-center">
                    <p className="text-8xl font-bold text-primary-color opacity-30 absolute top-[-30px]">
                      {item.serialNo}
                    </p>
                    <p className="text-2xl font-bold text-primary-color text-center">
                      {item.title}
                    </p>
                  </div>
                  <div className="w-full flex items-center text-[15px] justify-center px-5">
                    <p>{item.content}</p>
                  </div>
                </motion.div>
              ))}
          </div>
        </div>

        {/* Additional info */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="bg-primary-color bg-opacity-70 text-white px-8 lg:px-28 py-16"
        >
          <p className="text-xl font-bold md:text-3xl text-center italic underline">
            Particle Solar Power offers exceptional, tailored end-to-end solutions for solar module mounting structures, ensuring efficient installations and operations for various technologies including Poly, Mono, and HIT.
          </p>
        </motion.div>

        {/* SOLUTIONS WE PROVIDE */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className=" relative flex flex-col md:flex-row gap-28 items-center bg-secondary-color bg-opacity-10 mt-10  px-8 lg:px-28 py-8 justify-center"
        >
          <div className="absolute bg-bg4 w-full h-full bg-cover opacity-10"></div>
          <div>
            <img
              src={Bg2}
              alt="Logo"
              className="w-full h-[20rem] md:h-[25rem] bg-cover"
            />
          </div>
          <div>
            <p className="text-xl md:text-3xl lg:text-3xl font-semibold text-primary-color mb-2">
              Solar Solutions we provide
            </p>
            <div>
              {SOLUTIONS.map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="flex flex-row items-center"
                >
                  <HiCheckCircle className="inline-block mr-2 text-xl text-primary-color" />
                  <p className="text-lg md:text-xl lg:text-xl font-normal mb-2">
                    {item}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </>
    </MainContainer>
  );
}
